import { provideHttpClient } from '@angular/common/http';
import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from '@angular/router';
import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { APP_CONFIG } from './app/services/config/app-config.token';
import { AppConfig } from './app/services/config/config.model';

fetch('/assets/config/config.json')
    .then((res) => res.json() as Promise<AppConfig>)
    .then((cfg) => {
        console.log('Configuration loaded:', cfg);
        if (cfg.production) {
            enableProdMode();
        }
        // pass config to bootstrap process using an injection token
        return bootstrapApplication(AppComponent, {
            providers: [
                { provide: APP_CONFIG, useValue: cfg },
                provideRouter(routes),
                provideHttpClient(),
                provideAnimationsAsync('animations'),
            ],
        });
    })
    .catch((err) => {
        console.error('Failed to load config, bootstrapping in dev mode', err);
        return bootstrapApplication(AppComponent, {
            providers: [
                { provide: APP_CONFIG, useValue: {} as AppConfig },
                provideRouter(routes),
                provideHttpClient(),
                provideAnimationsAsync('animations'),
            ],
        });
    });
